$shm_dashboard_admin_user_dashboards $mol_page
	user_id \
	selected_user_id? \
	title <= page_title \
	tools /
		<= Section_switch $mol_switch
			value? <=> section_mode? \monitoring
			options *
				monitoring \Мониторинг упоминаний
				mention_stats \Статистика упоминаний
				wordstat \Wordstat
				agent \Агент
				logs \Логи
	body /
		<= User_label $mol_labeler
			title \Пользователь
			content /
				<= User_select $mol_select
					value? <=> selected_user_id? \
					dictionary <= user_options *
		<= Section_content $mol_view
			sub <= section_content /
	Monitoring_content $mol_view
		sub /
			<= Monitoring_user_settings $shm_ba_user_settings
				user_id <= active_user_id \
				user_data <= active_user_data null
				scope \monitoring
			<= Toolbar $mol_view
				sub /
					<= Dashboard_create $mol_button_major
						title \Добавить дашборд
						enabled <= dashboard_create_enabled false
						click? <=> dashboard_create? null
			<= Dashboard_list $mol_list
				rows <= body_rows /
	Agent_content $mol_view
		sub /
			<= Agent_user_settings $shm_ba_user_settings
				user_id <= active_user_id \
				user_data <= active_user_data null
				scope \agent
	Mention_stats_content $mol_view
		sub <= mention_stats_content_rows /
	Mention_stats_user_settings $shm_ba_user_settings
		user_id <= active_user_id \
		user_data <= active_user_data null
		scope \mention_stats
	Mention_stats_toolbar $mol_view
		sub /
			<= Mention_stats_create $mol_button_major
				title \Добавить задачу
				click? <=> mention_stats_create? null
	Mention_stats_list $mol_view
		sub <= mention_stats_task_rows /
	Mention_stats_task* $mol_view
		sub /
			<= Mention_stats_task_title* $mol_string_button
				value? <=> mention_stats_task_title_draft*? \
				submit? <=> mention_stats_task_title_commit*? null
				event *
					^
					blur? <=> mention_stats_task_title_commit*? null
					keydown? <=> mention_stats_task_title_keydown*? null
			<= Mention_stats_task_open* $mol_button_minor
				title \Открыть
				click? <=> mention_stats_task_open*? null
			<= Mention_stats_task_delete* $mol_pick
				align \center
				showed? <=> mention_stats_task_delete_showed*? false
				hint \Удалить задачу
				trigger_content /
					<= Mention_stats_task_delete_icon* $mol_icon_trash_can
				bubble_content /
					<= Mention_stats_task_delete_confirm* $mol_view
						sub /
							<= Mention_stats_task_delete_text* $mol_view
								sub / \Удалить задачу?
							<= Mention_stats_task_delete_yes* $mol_button_minor
								title \Да
								click? <=> mention_stats_task_delete*? null
							<= Mention_stats_task_delete_no* $mol_button_minor
								title \Нет
								click? <=> mention_stats_task_delete_cancel*? null
	Mention_stats_empty $mol_view
		sub / \Задач нет
	Mention_stats_dashboard $shm_ba_mention_stats_task
		task_id <= selected_mention_stats_task_id \
	Logs_content $mol_view
		sub <= log_content /
	Empty $mol_view
		sub / \Выберите пользователя
	Dashboard* $mol_list
		rows <= dashboard_rows* /
	Dashboard_head* $mol_view
		sub /
			<= Dashboard_title* $mol_string_button
				value? <=> dashboard_title_draft*? \
				submit? <=> dashboard_title_commit*? null
				event *
					^
					blur? <=> dashboard_title_commit*? null
					keydown? <=> dashboard_title_keydown*? null
			<= File_upload* $shm_button_open
				title \Загрузить файл
				accept \
				multiple true
				files? <=> upload_files*? /File
			<= Csv_to_duckdb* $shm_button_open
				title <= csv_to_duckdb_title* \csv -> duckdb
				enabled <= csv_to_duckdb_enabled* true
				accept \.csv,text/csv
				multiple true
				files? <=> csv_to_duckdb_files*? /File
			<= Dashboard_access* $mol_pick
				align \bottom
				showed? <=> dashboard_access_showed*? false
				auto /
					^
					<= dashboard_access_outside_listener* null
				trigger_content /
					<= dashboard_access_title* \
				bubble_content /
					<= Dashboard_access_bubble* $mol_list
						rows <= dashboard_user_rows* /
			<= Dashboard_tags* $mol_pick
				align \bottom
				showed? <=> dashboard_tags_showed*? false
				auto /
					^
					<= dashboard_tags_outside_listener* null
				trigger_content /
					<= dashboard_tags_title* \Теги
				bubble_content /
					<= Dashboard_tags_bubble* $mol_list
						rows <= dashboard_tag_rows* /
			<= Dashboard_delete* $mol_pick
				align \center
				showed? <=> dashboard_delete_showed*? false
				auto /
					^
					<= dashboard_delete_outside_listener* null
				trigger_content /
					<= Dashboard_delete_icon* $mol_icon_trash_can
				bubble_content /
					<= Dashboard_delete_bubble* $mol_view
						sub /
							<= Dashboard_delete_text* $mol_view
								sub / \Удалить дашборд?
							<= Dashboard_delete_yes* $mol_button_minor
								title \Да
								click? <=> dashboard_delete*? null
							<= Dashboard_delete_no* $mol_button_minor
								title \Нет
								click? <=> dashboard_delete_cancel*? null
	Dashboard_user* $mol_check_box
		checked? <=> dashboard_user_checked*? false
		label / <= dashboard_user_title* \
	Dashboard_tag* $mol_check_box
		title <= dashboard_tag_title* \
		checked? <=> dashboard_tag_checked*? true
	Upload_tags* $mol_view
		sub /
			<= Upload_tags_title* $mol_view
				sub / \Какие теги включить
			<= Upload_tags_list* $mol_list
				rows <= upload_tag_rows* /
			<= Upload_tags_actions* $mol_view
				sub /
					<= Upload_tags_confirm* $mol_button_major
						title \Загрузить
						click? <=> upload_confirm*? null
					<= Upload_tags_cancel* $mol_button_minor
						title \Отмена
						click? <=> upload_cancel*? null
	Upload_tag* $mol_check_box
		title <= upload_tag_title* \
		checked? <=> upload_tag_checked*? true
	Files* $mol_list
		rows <= file_rows* /
	File* $mol_view
		sub /
			<= File_title* $mol_view
				sub /
					<= File_title_text* $mol_string_button
						value? <=> file_title_draft*? \
						submit? <=> file_title_commit*? null
						event *
							^
							blur? <=> file_title_commit*? null
							keydown? <=> file_title_keydown*? null
					<= File_name* $mol_view
						sub / <= file_name* \
			<= File_delete* $mol_pick
				align \center
				showed? <=> file_delete_showed*? false
				auto /
					^
					<= file_delete_outside_listener* null
				trigger_content /
					<= File_delete_icon* $mol_icon_trash_can
				bubble_content /
					<= File_delete_bubble* $mol_view
						sub /
							<= File_delete_text* $mol_view
								sub / \Удалить файл?
							<= File_delete_yes* $mol_button_minor
								title \Да
								click? <=> file_delete*? null
							<= File_delete_no* $mol_button_minor
								title \Нет
								click? <=> file_delete_cancel*? null
	More* $mol_button_minor
		title \Еще
		click? <=> more? null
	Log_head $mol_view
		sub /
			<= Log_head_created $mol_view
				sub / \Дата
			<= Log_head_event $mol_view
				sub / \Событие
			<= Log_head_url $mol_view
				sub / \Страница
			<= Log_head_user_agent $mol_view
				sub / \User agent
	Log_row* $mol_view
		sub /
			<= Log_created* $mol_view
				sub / <= log_created* \
			<= Log_event* $mol_view
				sub / <= log_event* \
			<= Log_url* $mol_view
				sub / <= log_url* \
			<= Log_user_agent* $mol_view
				sub / <= log_user_agent* \
	No_logs $mol_view
		sub / \Логов нет
	Log_list $mol_list
		rows <= log_rows /
	Log_more $mol_button_minor
		title \Еще
		click? <=> log_more? null
	No_files* $mol_view
		sub / \Файлов нет
	No_dashboards $mol_view
		sub / \Дашбордов нет
	Wordstat_content $mol_view
		sub <= wordstat_content_rows /
	Wordstat_user_settings $shm_ba_user_settings
		user_id <= active_user_id \
		user_data <= active_user_data null
		scope \wordstat
	Wordstat_toolbar $mol_view
		sub /
			<= Wordstat_create $mol_button_major
				title \Добавить задачу
				click? <=> wordstat_create? null
	Wordstat_list $mol_view
		sub /
			<= Wordstat_table_head $mol_view
				sub /
					<= Wordstat_head_title $mol_view
						sub / \Название
					<= Wordstat_head_queries $mol_view
						sub / \Запросы
					<= Wordstat_head_subtasks $mol_view
						sub / \Кол-во подзадач
					<= Wordstat_head_period $mol_view
						sub / \Ежедневные данные с даты
					<= Wordstat_head_daily $mol_view
						sub / \Ежедневный сбор
					<= Wordstat_head_actions $mol_view
			<= Wordstat_rows $mol_list
				rows <= wordstat_task_rows /
	Wordstat_task* $mol_view
		sub /
			<= Wordstat_task_title* $mol_string_button
				value? <=> wordstat_task_title_draft*? \
				submit? <=> wordstat_task_title_commit*? null
				event *
					^
					blur? <=> wordstat_task_title_commit*? null
					keydown? <=> wordstat_task_title_keydown*? null
			<= Wordstat_task_queries* $mol_view
				sub / <= wordstat_task_queries* \
			<= Wordstat_task_subtasks* $mol_view
				sub / <= wordstat_task_subtasks* \
			<= Wordstat_task_period* $mol_view
				sub / <= wordstat_task_period* \
			<= Wordstat_task_daily* $mol_check_box
				title \
				checked? <=> wordstat_task_daily*? false
			<= Wordstat_task_actions* $mol_view
				sub /
					<= Wordstat_task_open* $mol_button_minor
						title \Открыть
						click? <=> wordstat_task_open*? null
					<= Wordstat_task_delete* $mol_pick
						align \center
						showed? <=> wordstat_task_delete_showed*? false
						hint \Удалить задачу
						trigger_content /
							<= Wordstat_task_delete_icon* $mol_icon_trash_can
						bubble_content /
							<= Wordstat_task_delete_confirm* $mol_view
								sub /
									<= Wordstat_task_delete_text* $mol_view
										sub / \Удалить задачу?
									<= Wordstat_task_delete_yes* $mol_button_minor
										title \Да
										click? <=> wordstat_task_delete*? null
									<= Wordstat_task_delete_no* $mol_button_minor
										title \Нет
										click? <=> wordstat_task_delete_cancel*? null
	Wordstat_empty $mol_view
		sub / \Задач нет
	Wordstat_dashboard $shm_wordstat_dashboard
		dashboard_id <= selected_wordstat_task_id \
		user_id <= active_user_id \
		administrating true
